import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    confirmacaoAcao:{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: 10,
        alignItems: "flex-start",
      },
}))

export default useStyles